import { imageFilesType } from "@/schemas/imagery-schema";

export enum IImageryFilter {
	"dust" = "dust",
	"sat" = "sat",
	"rad_ir" = "rad_ir",
}

export type IFetchImageryResult =
	| {
			isLoading: boolean;
			error: null;
			imageryData: imageFilesType[];
	  }
	| {
			isLoading: boolean;
			error: string;
			imageryData: never[];
	  };
